// src/pages/Dashboard/hooks/useSafetyReports.js
import { useEffect, useState } from "react";
import axios from "axios";
import { SAFETY_REPORT_API } from "../constants";
import { toArray } from "../utils/numberUtils";

/**
 * Fetches all safety reports once on mount and exposes
 * { reports, loading, error, refetch }.
 */
export default function useSafetyReports() {
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [reloadKey, setReloadKey] = useState(0);

  useEffect(() => {
    const ac = new AbortController();

    const run = async () => {
      try {
        setLoading(true);
        setError("");
        const res = await axios.get(SAFETY_REPORT_API, { signal: ac.signal });
        setReports(toArray(res.data));
      } catch (e) {
        if (axios.isCancel(e)) return;
        setError(e?.message || "Failed to load dashboard data");
      } finally {
        setLoading(false);
      }
    };

    run();
    return () => ac.abort();
  }, [reloadKey]);

  return {
    reports,
    loading,
    error,
    refetch: () => setReloadKey((k) => k + 1),
  };
}
